import { ExportFilterGroups } from "PFApp/analytics/types/export_analytics";
import { Filter, Value } from "PFTypes";

import { STANDARD_FILTERS_NAME } from "../use_filter_groups";

export const findPeriodFilter = <T extends Filter | Value>(
  filterGroups: ExportFilterGroups<T> = {}
): Filter | Value | null => {
  const [, periodFilter] =
    Object.values(filterGroups[STANDARD_FILTERS_NAME] || {})
      .flatMap((filterFamily) => Object.entries(filterFamily || {}))
      .find(([key]) => key === "period") ?? [];
  return periodFilter ?? null;
};
